import React from "react";
import { ThemeProvider } from "../lib";
export var wrapRootElement = function wrapRootElement(_ref) {
  var element = _ref.element;
  return /*#__PURE__*/React.createElement(ThemeProvider, null, element);
};